import posts from './content/blogPosts.js';
import projects from './content/projects.js';

export function findBlogBySlug(slug) {
  const post = posts.find((post) => post.slug === slug);
  return post;
}

export function findBlogsBySlugs(slugs = []) {
  const relatedPosts = [];

  for (const slug of slugs) {
    const post = findBlogBySlug(slug);

    if (!post) {
      console.warn(
        `[content] Project references unknown blog slug: "${slug}"`
      );
      continue;
    }

    relatedPosts.push(post);
  }

  return relatedPosts;
}

export function findProjectBySlug(slug) {
  const project = projects.find((project) => project.slug === slug);
  return project;
}

export function formatDate(dateString) {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));

  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
